import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import 'antd/dist/antd.min.css'; // or 'antd/dist/antd.less'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(<App />);

